(function () {
  'use strict';

  angular.module('wsLrs.services').factory("ResyncsService", ['$http', 'Api', function ($http, Api) {
    var getResyncTasks = function getResyncTasks(source, status, limit, offset, sortBy) {
      return $http({
        method: 'GET',
        url: Api.url('/resync-tasks', false, false),
        params: {
          source: source,
          status: status,
          order_by: sortBy,
          _limit: limit,
          _offset: offset
        }
      });
    };
    var updateResyncTask = function updateResyncTask(task) {
      return $http.put(Api.url("/resync-tasks/".concat(task.id)), task);
    };
    var refreshResyncLock = function refreshResyncLock(orgId) {
      var params = {
        tenantId: orgId
      };
      return $http.get(Api.url('/cache/resync-lock', true), {
        params: params
      });
    };
    var freeResyncLock = function freeResyncLock(orgId) {
      var params = {
        tenantId: orgId
      };
      return $http.delete(Api.url('/cache/resync-lock', true), {
        params: params
      });
    };
    return {
      getResyncTasks: getResyncTasks,
      updateResyncTask: updateResyncTask,
      refreshResyncLock: refreshResyncLock,
      freeResyncLock: freeResyncLock
    };
  }]);
})();
